// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"117":"a20f1582","231":"5a9cac3f","394":"5955d36b","983":"2e168736"}[chunkId] + ".chunk.css";
};